<template lang="pug">
  #home
    Navbar
    Header
    #section1
      Section1
      Section1s1
    #section2
      Section2
      Section2s1
    #section3
      Section3
      Section3s1
    Videos
    Footer
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Home/Header.vue";
import Section1 from "@/components/Home/Section1.vue";
import Section1s1 from "@/components/Home/Section1s1.vue";
import Section2 from "@/components/Home/Section2.vue";
import Section2s1 from "@/components/Home/Section2s1.vue";
import Section3 from "@/components/Home/Section3.vue";
import Section3s1 from "@/components/Home/Section3s1.vue";
import Videos from "@/components/Home/Videos.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    Header,
    Section1,
    Section1s1,
    Section2,
    Section2s1,
    Section3,
    Section3s1,
    Videos,
    Footer
  }
};
</script>

<style lang="scss">
#home {
  background-image: linear-gradient(to bottom, #0a1d59, #00218b);
}
</style>
